"use client";

import { useRef, useEffect, useState } from "react";
import SignatureCanvas from "react-signature-canvas";
import Button from "../../../components/Button";
import overlayStyles from "../../../css/components/overlaymodal-animations.module.css";
import styles from "../css/PharmacistSignature.module.css";
import PrescriptionPreviewModal from "./PrescriptionPreviewModal";

export default function PharmacistSignatureModal({
  isOpen,
  onClose,
  onNext,
  initialSignature = null,
  openPreviewOnNext = true, // new optional behavior to open preview modal
  previewProps = {}, // optional props passed to preview modal
  nextLabel = "Next",
  title = "Pharmacist Signature",
}) {
  const sigRef = useRef();
  const [signatureData, setSignatureData] = useState(null);
  const [showPreview, setShowPreview] = useState(false);

  // Load existing signature if provided
  useEffect(() => {
    if (isOpen && initialSignature && sigRef.current) {
      sigRef.current.fromDataURL(initialSignature);
    }
  }, [isOpen, initialSignature]);

  const handleClearSignature = () => {
    sigRef.current.clear();
  };

  const handleNext = (e) => {
    // Prevent any parent form submission or event bubbling that might close the modal
    e?.preventDefault?.();
    e?.stopPropagation?.();
    if (sigRef.current.isEmpty()) {
      alert("Please provide a signature before continuing.");
      return;
    }
    const data = sigRef.current.getCanvas().toDataURL("image/png");
    setSignatureData(data);
    if (openPreviewOnNext) {
      // Show the preview immediately and DO NOT call onNext here
      // to avoid the parent closing this modal before preview renders.
      setShowPreview(true);
      return;
    }
    // Fallback: legacy flow without preview
    onNext?.(data);
  };

  if (!isOpen) return null;

  // When preview is toggled, show ONLY the preview modal immediately
  if (openPreviewOnNext && showPreview) {
    console.log('[PharmacistSignatureModal] opening PrescriptionPreviewModal with props', {
      previewProps,
      signatureData,
    });
    return (
      <PrescriptionPreviewModal
        isOpen={true}
        onClose={() => setShowPreview(false)}
        onBack={() => setShowPreview(false)}
        onProceed={() => {
          setShowPreview(false);
          // Now notify parent and then close this modal
          onNext?.(signatureData);
          onClose?.();
        }}
        {...previewProps}
      />
    );
  }

  return (
    <div className={`${overlayStyles.modalOverlay} ${overlayStyles.show}`}>
      <div className={`${overlayStyles.modalContent} ${styles.modalContent}`}>
        <button className={overlayStyles.closeButton} onClick={onClose}>
          ×
        </button>
        <h2 className={styles.title}>{title}</h2>
        <SignatureCanvas
          ref={sigRef}
          penColor="black"
          canvasProps={{
            className: styles.canvas,
            width: 600,
            height: 200,
          }}
        />
        <div className={styles.buttonContainer}>
          <Button type="button" onClick={handleClearSignature} variant="secondary" noHover>
            Clear
          </Button>
          <Button type="button" onClick={handleNext} variant="primary" noHover>
            {nextLabel}
          </Button>
        </div>
      </div>
    </div>
  );
}
